export const CONNECTORS_UI_PATH = '/computer/connectors';
export const CONNECTOR_QUERY_PARAMS = {
    GCAL_CONNECT: 'gcal_connect',
    CONNECTOR_COMPLETE: 'connector_complete',
};
/** Set on a callback redirect after a rejected connection attempt. */
export const CONNECTOR_ERROR_QUERY_PARAM = 'connector_error';
export const BROADCAST_CHANNELS = {
    UPSELL_CONNECTOR: 'upsell-connector-channel',
};
export const CALENDAR_PROVIDER = {
    GOOGLE: 'google',
    OUTLOOK: 'outlook',
};
export const ConnectorId = {
    GCAL: 'gcal',
    OUTLOOK: 'outlook',
    GOOGLE_DRIVE: 'google_drive',
    ONEDRIVE: 'onedrive',
    SHAREPOINT: 'sharepoint',
    DROPBOX: 'dropbox',
    BOX: 'box',
    NOTION: 'notion',
    FACTSET: 'factset',
};
//# sourceMappingURL=connectors.js.map